import data_control from "../../../../engines/libs/data_control";
import getOneBundle, { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../BundleResourceConfig";
import { cooperativeInterface } from "./cooperativeConst";

const {ccclass, property} = cc._decorator;

@ccclass
export default class cooperativeItem extends cc.Component {

    @property({type:cc.Label,displayName:"名字文本"})
    lb_Name:cc.Label = null;

    @property({type:cc.Label,displayName:"银行名字"})
    bankLb:cc.Label = null;

    @property({type:cc.Label,displayName:"钱文本"})
    moneyLb:cc.Label = null;

    @property({type:cc.Label,displayName:"描述文本"})
    lb_Explain:cc.Label = null;

    @property({type:cc.Node,displayName:"视频图标"})
    video:cc.Node = null;

    @property({type:cc.Sprite,displayName:"银行icon"})
    iconSp:cc.Sprite = null;

    data:cooperativeInterface = null;

    selectFun:(node:cc.Node)=>void;

    bindData(data:cooperativeInterface,selectFun:(node:cc.Node)=>void){
        this.data = data;
        this.video.active = data.videoFlag;
        this.selectFun = selectFun;
        this.updateItem();
    }
    onBtnContact(){
        this.selectFun && this.selectFun(this.node);
    }

    updateItem(){
        this.lb_Name.string = this.data.name;
        this.lb_Explain.string = this.data.explain;
        this.bankLb.string = this.data.bankName;
        this.moneyLb.string = `${data_control.getNumberFormat(this.data.param["money"])}元`;
        this.loadIcon();
    }

    loadIcon(){
        let iconName:string = this.data.icon;
        let bundle = getOneBundleByInstant(BUNDLE_SMALL_NAME.cooperativeGameBundle);
        bundle.load(`cooperativeAssets/icon/${iconName}`,cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>{
            if(err){
                console.debug("加载银行icon失败",err);
                return;
            }
            this.iconSp.spriteFrame = spr;
        });
    }

}